import React from 'react';
import Footer from '../../components/Footers/Footer';
import IndexNavbar from 'components/Navbars/IndexNavbar';

const CGU = () => {
  // Styles réutilisables
  const sectionStyle = {
    marginBottom: '2.5rem',
    background: 'rgba(15, 23, 42, 0.5)',
    borderRadius: '12px',
    overflow: 'hidden',
    border: '1px solid rgba(255, 255, 255, 0.05)'
  };

  const sectionHeaderStyle = {
    fontSize: '1.5rem',
    fontWeight: 700,
    color: '#ffffff',
    margin: 0,
    padding: '1.25rem 2rem',
    background: 'linear-gradient(90deg, rgba(14, 165, 233, 0.2) 0%, rgba(59, 130, 246, 0.2) 100%)',
    borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem'
  };

  const sectionContentStyle = {
    padding: '1.5rem 2rem'
  };

  const paragraphStyle = {
    color: '#e2e8f0', 
    margin: '0 0 1rem 0',
    lineHeight: '1.7'
  };

  const listStyle = {
    paddingLeft: '1.5rem',
    margin: '0 0 1rem 0'
  };

  const listItemStyle = {
    marginBottom: '0.5rem',
    lineHeight: '1.7',
    color: '#e2e8f0'
  };

  const highlightStyle = {
    color: '#0ea5e9',
    fontWeight: 600
  };

  const linkStyle = {
    color: '#0ea5e9',
    textDecoration: 'none',
    cursor: 'pointer'
  };

  const numberBadge = (number) => (
    <span style={{
      backgroundColor: '#0ea5e9',
      color: 'white',
      borderRadius: '9999px',
      width: '2rem',
      height: '2rem',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '0.875rem',
      fontWeight: 600,
      flexShrink: 0
    }}>
      {number}
    </span>
  );

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      background: 'linear-gradient(135deg, #0f172a 0%, #111827 35%, #0b1220 100%)',
      color: 'white',
      padding: '2rem 0',
      paddingTop: '6rem'
    }}>
      <main style={{
        width: '100%',
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 1rem'
      }}>
        <div style={{ 
          textAlign: 'center', 
          marginBottom: '3rem',
          padding: '2rem',
          background: 'rgba(255, 255, 255, 0.03)',
          borderRadius: '16px',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <h1 style={{
            fontSize: '2.5rem',
            fontWeight: 800,
            color: '#ffffff',
            marginBottom: '1rem',
            background: 'linear-gradient(90deg, #0ea5e9, #3b82f6)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            display: 'inline-block'
          }}>
            Conditions Générales d'Utilisation
          </h1>
          <p style={{
            fontSize: '1.125rem',
            color: '#94a3b8',
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            En vigueur au 02 novembre 2025
          </p>
        </div>

        <div style={{
          backgroundColor: 'rgba(15, 23, 42, 0.7)',
          borderRadius: '16px',
          boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.3), 0 8px 10px -6px rgba(0, 0, 0, 0.2)',
          overflow: 'hidden',
          border: '1px solid rgba(255, 255, 255, 0.1)'
        }}>
          <div style={{ 
            padding: '2.5rem',
            background: 'linear-gradient(180deg, rgba(30, 41, 59, 0.5) 0%, rgba(15, 23, 42, 0.7) 100%)'
          }}>

            {/* Article 1 : Préambule */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(1)}
                Préambule
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Les présentes conditions générales d'utilisation (ci-après les <span style={highlightStyle}>« CGU »</span>) ont pour objet l'encadrement juridique des modalités de mise à disposition des services du site AidFoundation (ci-après <span style={highlightStyle}>« le site »</span>) et leur utilisation par <span style={highlightStyle}>« l'Utilisateur »</span>.
                </p>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Toute inscription ou utilisation du site implique l'acceptation sans aucune réserve ni restriction des présentes CGU par l'utilisateur. Lors de l'inscription sur le site via le Formulaire d'inscription, chaque utilisateur accepte expressément les présentes CGU en cochant la case précédant le texte suivant : « Je reconnais avoir lu et compris les CGU et je les accepte ».
                </p>
              </div>
            </section>

            {/* Article 2 : Définitions */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(2)}
                Définitions
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  La présente clause a pour objet de définir les différents termes essentiels du contrat :
                </p>
                <ul style={listStyle}>
                  <li style={listItemStyle}><strong style={highlightStyle}>Utilisateur</strong> : ce terme désigne toute personne qui utilise le site ou l'un des services proposés par le site.</li>
                  <li style={listItemStyle}><strong style={highlightStyle}>Contenu utilisateur</strong> : ce sont les données transmises par l'Utilisateur au sein du site.</li>
                  <li style={listItemStyle}><strong style={highlightStyle}>Membre</strong> : l'Utilisateur devient membre lorsqu'il est identifié sur le site.</li>
                  <li style={listItemStyle}><strong style={highlightStyle}>Identifiant et mot de passe</strong> : c'est l'ensemble des informations nécessaires à l'identification d'un Utilisateur sur le site.</li>
                  <li style={{...listItemStyle, marginBottom: 0}}><strong style={highlightStyle}>Compte</strong> : espace personnel de l'Utilisateur sur le site, accessible avec ses identifiants.</li>
                </ul>
              </div>
            </section>

            {/* Article 3 : Accès aux services */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(3)}
                Accès aux services
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Le site permet à l'Utilisateur un accès gratuit aux services suivants :
                </p>
                <ul style={listStyle}>
                  <li style={listItemStyle}>Consultation des produits et services bancaires</li>
                  <li style={listItemStyle}>Espace client personnel</li>
                  <li style={listItemStyle}>Service client en ligne</li>
                  <li style={listItemStyle}>Outils de gestion financière</li>
                  <li style={listItemStyle}>Informations et actualités financières</li>
                </ul>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Le site est accessible gratuitement en tout lieu à tout Utilisateur ayant un accès à Internet. Tous les frais supportés par l'Utilisateur pour accéder au service (matériel informatique, logiciels, connexion Internet, etc.) sont à sa charge.
                </p>
              </div>
            </section>

            {/* Article 4 : Création du compte */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(4)}
                Création du compte
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Pour accéder aux services, l'Utilisateur doit créer un compte en renseignant les informations demandées. L'Utilisateur s'engage à fournir des informations exactes et à les mettre à jour régulièrement.
                </p>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  L'Utilisateur est seul responsable de la confidentialité de son identifiant et de son mot de passe. Toutes les actions effectuées à partir de son compte seront présumées avoir été effectuées par l'Utilisateur.
                </p>
              </div>
            </section>

            {/* Article 5 : Services bancaires */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(5)}
                Services bancaires
              </h2>
              <div style={sectionContentStyle}>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Les services bancaires proposés sur le site sont soumis à des conditions spécifiques qui seront communiquées à l'Utilisateur lors de la souscription. L'ouverture de compte et l'octroi de services sont soumis à l'acceptation préalable de AidFoundation.
                </p>
              </div>
            </section>

            {/* Article 6 : Responsabilités */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(6)}
                Responsabilités
              </h2>
              <div style={sectionContentStyle}>
                <h3 style={{...paragraphStyle, fontSize: '1.2rem', marginBottom: '0.75rem'}}>6.1 Responsabilité de l'Utilisateur</h3>
                <p style={paragraphStyle}>
                  L'Utilisateur s'engage à ne pas utiliser le site pour :
                </p>
                <ul style={listStyle}>
                  <li style={listItemStyle}>Enfreindre les lois et règlements en vigueur</li>
                  <li style={listItemStyle}>Porter atteinte aux droits des tiers</li>
                  <li style={listItemStyle}>Diffuser des contenus illicites, diffamatoires ou injurieux</li>
                  <li style={listItemStyle}>Tenter d'accéder aux comptes d'autres utilisateurs</li>
                  <li style={listItemStyle}>Perturber le bon fonctionnement du site</li>
                </ul>
                
                <h3 style={{...paragraphStyle, fontSize: '1.2rem', margin: '1.5rem 0 0.75rem'}}>6.2 Responsabilité de AidFoundation</h3>
                <p style={paragraphStyle}>
                  AidFoundation s'engage à fournir un service de qualité mais ne peut garantir :
                </p>
                <ul style={{...listStyle, marginBottom: 0}}>
                  <li style={listItemStyle}>L'absence d'interruption ou d'erreur dans le fonctionnement du site</li>
                  <li style={listItemStyle}>L'exactitude et l'exhaustivité des informations publiées</li>
                  <li style={{...listItemStyle, marginBottom: 0}}>L'absence de virus ou d'éléments nuisibles</li>
                </ul>
              </div>
            </section>

            {/* Article 7 : Propriété intellectuelle */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(7)}
                Propriété intellectuelle
              </h2>
              <div style={sectionContentStyle}>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  La structure du site, ainsi que les textes, graphiques, images, sons et vidéos la composant, sont la propriété de AidFoundation ou de ses partenaires. Toute reproduction, représentation, utilisation ou adaptation, sous quelque forme que ce soit, de tout ou partie des éléments du site sans l'accord préalable écrit de AidFoundation est strictement interdite.
                </p>
              </div>
            </section>

            {/* Article 8 : Données personnelles */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(8)}
                Données personnelles
              </h2>
              <div style={sectionContentStyle}>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Les données personnelles collectées sur le site sont traitées conformément à notre <a href="/confidentialite" style={linkStyle}>Politique de confidentialité</a>.
                </p>
              </div>
            </section>

            {/* Article 9 : Cookies */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(9)}
                Cookies
              </h2>
              <div style={sectionContentStyle}>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Le site utilise des cookies. Pour en savoir plus sur l'utilisation des cookies, veuillez consulter notre <a href="/cookies" style={linkStyle}>Politique relative aux cookies</a>.
                </p>
              </div>
            </section>

            {/* Article 10 : Liens hypertextes */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(10)}
                Liens hypertextes
              </h2>
              <div style={sectionContentStyle}>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Le site peut contenir des liens hypertextes vers d'autres sites. AidFoundation n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
                </p>
              </div>
            </section>

            {/* Article 11 : Modification des CGU */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(11)}
                Modification des CGU
              </h2>
              <div style={sectionContentStyle}>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  AidFoundation se réserve le droit de modifier les présentes CGU à tout moment. Les modifications entreront en vigueur dès leur publication en ligne. L'Utilisateur est invité à consulter régulièrement cette page.
                </p>
              </div>
            </section>

            {/* Article 12 : Droit applicable et juridiction compétente */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(12)}
                Droit applicable et juridiction compétente
              </h2>
              <div style={sectionContentStyle}>
                <p style={{...paragraphStyle, marginBottom: 0}}>
                  Les présentes CGU sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents.
                </p>
              </div>
            </section>

            {/* Article 13 : Contact */}
            <section style={sectionStyle}>
              <h2 style={sectionHeaderStyle}>
                {numberBadge(13)}
                Contact
              </h2>
              <div style={sectionContentStyle}>
                <p style={paragraphStyle}>
                  Pour toute question concernant les présentes CGU, vous pouvez nous contacter :
                </p>
                <div style={{
                  padding: '1.5rem',
                  background: 'rgba(14, 165, 233, 0.1)',
                  borderRadius: '8px',
                  border: '1px solid rgba(14, 165, 233, 0.2)'
                }}>
                  <p style={{...paragraphStyle, margin: '0 0 0.5rem 0', fontWeight: 600}}>AidFoundation</p>
                  <p style={{...paragraphStyle, margin: '0 0 0.5rem 0'}}>Service Client</p>
                  <p style={{...paragraphStyle, margin: '0 0 0.5rem 0'}}>123 Rue de la Finance</p>
                  <p style={{...paragraphStyle, margin: '0 0 0.5rem 0'}}>75001 Paris, France</p>
                  <p style={{...paragraphStyle, margin: '0 0 0.5rem 0'}}>
                    Email : <a href="mailto:contact@aidfoundation.eu" style={linkStyle}>contact@aidfoundation.eu</a>
                  </p>
                  <p style={{...paragraphStyle, margin: 0}}>
                    Téléphone : <a href="tel:+33774137802" style={linkStyle}>+33 7 74 13 78 02</a>
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default CGU;